import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from 'srcReact/helpers/rootReducer'

const loggerMiddleware = createLogger({
  predicate: () => process.env.NODE_ENV === 'development',
  duration: true,
})

const middlewares = [thunkMiddleware, loggerMiddleware]
const appliedMiddleWare = applyMiddleware(...middlewares)

const composeEnhancers =
  process.env.NODE_ENV === 'development'
    ? composeWithDevTools({
        // Specify name here, actionsBlacklist, actionsCreators and other options if needed
      })
    : compose

// preload initialState from localstorage in case of need
const store = createStore(rootReducer, {}, composeEnhancers(appliedMiddleWare))

export default store
